/**
 * @description a display string with value as Value (0 - <10) and unit pair
 * Supported display units are K (Thousands), M (Millions), B (Billions), T (Trillions)
 * e.g 1,000,000 => 1M, 1,000,000,000 => 1B.
 *
 * Note that any value over 10 Trillion, unit is capped to trillions
 * e.g. 15,000,000,000,000 is converted to 15T
 * @param value
 * @returns a display string with value as Value and unit pair
 *
 */

export const numberDisplayFormatter: (value: number) => string = (
  value: number
) => {
  const scaleUnitsDisplayMap = new Map<string, string>([
    ['0', ''],
    ['3', 'K'],
    ['6', 'M'],
    ['9', 'B'],
    ['12', 'T'],
  ]);

  // convert number to exponent form e.g. 3000 => 3e+3
  // to get the sca
  const normalisedValue = String(value.toExponential());
  const normalisedValueSplit = normalisedValue.split('e');

  const mantissa = normalisedValueSplit[0];
  const exponent = normalisedValueSplit[1].substring(
    1,
    normalisedValueSplit[1].length
  );

  let multiplierPower: number;
  let displayExponent: string | undefined;

  const exponentVal = parseInt(exponent, 10);
  const mantissaVal = parseFloat(mantissa);

  let displayMantissa = `${mantissaVal}`;
  displayExponent = scaleUnitsDisplayMap.get(exponent);
  /* cap scale to highest supported */
  if (exponentVal > 12) {
    multiplierPower = exponentVal - 12;

    displayMantissa = (mantissaVal * 10 ** multiplierPower).toFixed(0);
    displayExponent = scaleUnitsDisplayMap.get('12') as string;
  } else if (typeof displayExponent === 'undefined') {
    const newExponent: number = Math.floor(exponentVal / 3) * 3;
    multiplierPower = exponentVal % 3;

    displayExponent = scaleUnitsDisplayMap.get(`${newExponent}`);
    displayMantissa = (mantissaVal * 10 ** multiplierPower).toFixed(0);
  }

  return `${displayMantissa}${displayExponent}`;
};

export const numberRoundDisplayFormatter: (value: number) => string = (
  value: number
) => {
  if (!value) return '-';
  return `${Math.round(value * 100) / 100}`;
};
